<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12 min-vh-100 d-flex flex-column justify-content-center">
                <div class="row">
                    <div class="col-lg-6 col-md-8 mx-auto">
                        <div class="card rounded shadow shadow-lg">
                            <div class="card-header bg-light">
                                <img :src="tnkcBanner" class="img-fluid"/>
                            </div>

                            <div class="card-body">
                                <form @submit.prevent="login">
                                    <div class="form-group row">
                                        <label for="username" class="col-md-4 col-form-label text-md-right font-weight-bold">Username</label>
                                        <div class="col-md-6">
                                            <input type="text" name="username" id="username" class="form-control" v-model="username" required autofocus>
                                        </div>
                                    </div>
                                    <br>

                                    <div class="form-group row">
                                        <label for="password" class="col-md-4 col-form-label text-md-right font-weight-bold">Password</label>
                                        <div class="col-md-6">
                                            <div class="input-group">
                                                <input type="password" name="password" id="password" class="form-control" v-model="password"  required autofocus>
                                                <div class="input-group-append">
                                                    <button class="btn tnkc-secondary" type="button" title="Show Password" @click="showPassword">
                                                        <font-awesome-icon :icon="this.icon"/>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <br>

                                    <div class="form-group row mb-0">
                                        <div class="col-md-8 offset-md-3">
                                            <button type="submit" class="btn tnkc-primary font-weight-bold">
                                                <font-awesome-icon icon="sign-in-alt" />Login
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import TnkcBanner from '../assets/tnkc-banner.png';
  import {mapGetters,mapActions} from 'vuex';
  import {appMixins} from '../mixins/app.mixins';

  export default {
    name: 'Login',
    mixins:['appMixins'],
    data() {
      return {
        tnkcBanner: TnkcBanner,
        username : '',
        password : '',
        log_type : 1,
        icon : "eye-slash",
      };
    },

    methods: {

      ...mapActions(['loginUser']),

      login(){
        const params = {
          username: this.username,
          password: this.password,
          log_type: this.log_type
        }
        this.loginUser(params).then((response)=>{
          if(response == true){
            this.goToMain();
          }
        });
      },

      goToMain(){
        //todo replace this into dashboard
        this.$router.push({name:'Main'}).catch((error)=>{});
      },

      showPassword() {
        const xinput = document.getElementById('password');
        const x = document.getElementById('xicon');
        if (xinput.type == 'password') {
          xinput.type = 'text';
          this.icon = "eye";
        } else {
          xinput.type = 'password';
          this.icon = "eye-slash";
        }
      },
    },

    computed: {

      ...mapGetters(['userLogin','setLoading','isLoggedIn','authStatus']),

    },
  };
</script>

<style scoped>

</style>